export default "__VITE_PUBLIC_ASSET__43fdbe9c__"